"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.getStore = satcheljs_1.createStore('optionsViewState', {
    isFullOptionsShown: false,
    isSaving: false,
    currentCategoryKey: null,
    currentSubCategoryKey: null,
    currentSubCategoryState: null,
    currentOptionKey: null,
    searchTerm: '',
});
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/store/store.js
// module id = 2113
// module chunks = 2 38 40 43 65 105